<template>
  <div class="container">
    <h1>Html Sending email example code In Contact Us Form</h1>
    <HtmlGist />
  </div>
</template>
<script>
import HtmlGist from './HtmlGist'
export default {
  name: 'Html',
  components: {
    HtmlGist
  }
}
</script>

<style scoped>
img{
  width: 90%;
}

</style>
